import React, { FC } from "react";
import { useParams } from "react-router";
import { AccessControl } from "../../components/auth";
import { Permission } from "../../hooks";
import { MatterTemplateEditorContainer } from "../../containers/configuration/library-content/matter-template-editor-container";

export const MatterTemplateEditor: FC = () => {
  const { matterId } = useParams();
  return (
    <AccessControl permissions={[Permission.MATTER_TEMPLATE_EDITOR]}>
      <MatterTemplateEditorContainer matterTemplateId={Number.parseInt(matterId || "")} />
    </AccessControl>
  );
};
